export enum RaffleListFilter {
  Popularity = 'popularity',
  Date = 'date',
  Price = 'price',
  PriceDesc = 'price-desc',
  ValueDesc = 'value-desc'
}
